<template>
	<v-container>
		<div class="revision-header d-flex align-center justify-space-between mt-1 py-1 px-2">
			<h4>
				Rev {{revision.revision}} - Fecha: {{revision.created_at | toDate}} -  {{revision.created_at | toHour}} - {{ revision.created_by_user && revision.created_by_user.name }}
			</h4>
			<v-chip
				color="white"
				v-if="isFirstRevision"
				x-small
				outlined>
				Revisión Inicial
			</v-chip>
		</div>
		<div class="revision-container pa-2">
			<v-row align="start" class="mt-0">
				<v-col cols="12" md="7">
					<h4 class="mb-1">Descripción</h4>
					<div v-html="revision.description"></div>
				</v-col>
				<v-col cols="12" md="5">
					<div class="revision-cost-container w-100">
						<table width="100%" class="rounded-lg">
							<tbody>
								<tr>
									<td class="px-2 caption">
										<v-icon color="#2D4B95" small class="mr-1">mdi-currency-usd</v-icon> Costo Directo:
									</td>
									<td class="px-2 text-right" :class="currentAdicional.type == 3 ? 'red--text':''">
										<span class="font-weight-bold" v-if="currentAdicional.type == 3">-</span>{{revision.currency_info.code}}${{revision.direct_cost | toThousandFilter}}
									</td>
								</tr>
								<tr>
									<td class="px-2 caption">
										<v-icon color="#2D4B95" small class="mr-1">mdi-currency-usd</v-icon> Gasto General:
									</td>
									<td class="px-2 text-right" :class="currentAdicional.type == 3 ? 'red--text':''">
										<span class="font-weight-bold" v-if="currentAdicional.type == 3">-</span>{{revision.currency_info.code}}${{revision.general_expenses | toThousandFilter}}
									</td>
								</tr>
								<tr>
									<td class="px-2 caption">
										<v-icon color="#2D4B95" small class="mr-1">mdi-finance</v-icon> Utilidad:
									</td>
									<td class="px-2 text-right" :class="currentAdicional.type == 3 ? 'red--text':''">
										<span class="font-weight-bold" v-if="currentAdicional.type == 3">-</span>{{revision.currency_info.code}}${{revision.utility | toThousandFilter}}
									</td>
								</tr>
								<tr>
									<td class="px-2 caption">
										<v-icon color="#2D4B95" small class="mr-1">mdi-cash-multiple</v-icon> Total Solicitado:
									</td>
									<td class="px-2 text-right font-weight-bold" :class="currentAdicional.type == 3 ? 'red--text':''">
										<span class="font-weight-bold" v-if="currentAdicional.type == 3">-</span>{{revision.currency_info.code}}${{revision.total_requested | toThousandFilter}}
									</td>
								</tr>
							</tbody>
						</table>
						<!-- <div class="px-2 revision-cost-container-inner">
							<v-icon color="#2D4B95" class="mr-2">mdi-currency-usd</v-icon> Costo Directo: {{revision.currency_info.code}}${{revision.direct_cost | toThousandFilter}}
						</div>
						<div class="px-2 revision-cost-container-inner dark">
							<v-icon color="#2D4B95" class="mr-2">mdi-currency-usd</v-icon> Gasto General: {{revision.currency_info.code}}${{revision.general_expenses | toThousandFilter}}
						</div>
						<div class="px-2 revision-cost-container-inner">
							<v-icon color="#2D4B95" class="mr-2">mdi-finance</v-icon> Utilidad: {{revision.currency_info.code}}${{revision.utility | toThousandFilter}}
						</div>
						<div class="px-2 revision-cost-container-inner dark">
							<v-icon color="#2D4B95" class="mr-2">mdi-cash-multiple</v-icon> Total Solicitado: {{revision.currency_info.code}}${{revision.total_requested | toThousandFilter}}
						</div> -->
					</div>
				</v-col>
			</v-row>
			<v-row align="start" class="mt-0">
				<v-col cols="12" md="12">
					<div class="d-flex justify-space-between">
						<p class="mb-0 text-primary font-weight-bold">
							{{revision.attachments.length === 0 ? 'Sin ':''}}
							Adjuntos
						</p>
						<div v-if="revision.attachments.length > 0">
							<!-- <v-btn
								class="mx-2 my-1"
								rounded
								color="#2D4B95"
								dark
								x-small
								:loading="loadingFilePath"
								@click="() => downloadAttachments(revision.attachments)"
							>
								<v-icon dark small>mdi-paperclip</v-icon>
								<p class="mb-0 ml-2">Descargar Todo</p>
							</v-btn> -->
							<v-btn
								class="mx-2 my-1"
								rounded
								color="#5E85EF"
								dark
								x-small
								:loading="loadingFilePath"
								@click="() => showAttachments = !showAttachments"
							>
								<v-icon dark small>{{showAttachments ? 'mdi-chevron-up':'mdi-chevron-down'}}</v-icon>
								<p class="mb-0 ml-2">{{showAttachments ? 'Ocultar':'Ver Más'}}</p>
							</v-btn>
						</div>
					</div>
					<v-scroll-y-transition leave-absolute v-if="revision.attachments.length > 0">
						<div v-if="showAttachments" :key="1">
							<MediaGallery
								v-if="hasAttachments"
								:itemscope="attachments" />
							<GlobalFileViewer
								:document-item="viewerDocumentItem"
								:forge-item="viewerForgeItem"
								@close="closeAttachmentViewer"
								@minimize-file="minimizeAttachmentViewer"
								@open-morphable="openItemMorphable"
								@error="onViewerError"
								@load="onViewerLoad"
							/>
							<v-divider class="my-2"></v-divider>
							<div class="adjuntos-container"
								v-if="revision.attachments.filter(item => !item.pathmedia).length > 0">
								<div class="d-flex flex-row align-center justify-space-between my-2 py-1 px-2"
									:class="index%2 != 0 ? 'bg-dark-list':''"
									:key="index"
									v-for="(attachment, index) in revision.attachments.filter(item => !item.pathmedia)">
									<p class="mb-0">{{attachment.name}}</p>
									<p class="mb-0 text-primary">
										<AttachmentPreviewButton
											:attachment="attachment"
											:loading="loadingFilePath"
											compact
											@preview="previewAttachment"
										/>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													class="mx-1 my-1"
													color="#5E85EF"
													dark
													small
													icon
													:loading="loadingFilePath"
													v-bind="attrs"
													v-on="on"
													@click="getFilesUrl(attachment, true)"
												>
													<v-icon color="white" small class="info-icon small-icon">mdi-open-in-new</v-icon>
												</v-btn>
											</template>
											<span>Visualizar en navegador</span>
										</v-tooltip>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													class="mx-1 my-1"
													color="#5E85EF"
													dark
													x-small
													:icon="$vuetify.breakpoint.mobile"
													:loading="loadingFilePath"
													v-bind="attrs"
													v-on="on"
													@click="getFilesUrl(attachment, true, true)"
												>
													<v-icon color="white" small class="bg-light-blue mr-2" :class="$vuetify.breakpoint.mobile ? 'info-icon':''">mdi-cloud-download-outline</v-icon>
													<p class="mb-0" v-if="!$vuetify.breakpoint.mobile">Descargar</p>
												</v-btn>
											</template>
											<span>Descargar archivo</span>
										</v-tooltip>
									</p>
								</div>
							</div>
						</div>
					</v-scroll-y-transition>
				</v-col>
			</v-row>
			<v-divider class="my-4" />
			<RevisionObservation
				:revision="revision"
				:isLastRevision="isLastRevision"
				:needToReloadListing="needToReloadListing"
				@scrollToAddObservation="scrollToAddObservation"
				@draftIdSet="(draftId) => $emit('draftIdSet', draftId)"
				@minimizeParent="(draftId) => $emit('minimizeParent', draftId)"
				:beforeNavigate="beforeNavigate"
			/>
		</div>
	</v-container>
</template>

<script>
import MediaGallery from '@/components/Globals/Helpers/MediaGallery'
import GlobalFileViewer from '@/components/Globals/Helpers/GlobalFileViewer'
import AttachmentPreviewButton from '@/components/Globals/Helpers/AttachmentPreviewButton'
import {getPublicUrl} from '@/helpers/api/tasks'
import {getParentElement} from '@/helpers/api/general'
import RevisionObservation from './RevisionObservation.vue'

export default {
	name: 'RevisionSingleContainer',
	components: {
		MediaGallery,
		GlobalFileViewer,
		AttachmentPreviewButton,
		RevisionObservation
	},
	computed: {
    hasAttachments() {
      return this.revision.attachments.some(item => item.pathmedia)
    },
    attachments() {
      return this.revision.attachments
        .filter(item => item.pathmedia)
        .map(item => item.pathmedia)
    },
		iAmItoAdditional(){
			return this.currentAdicional.userprojectjobtype.job_type_id !== 4
		},
	},
	props: {
		isFirstRevision: {
			type: Boolean,
			required: true
		},
		isLastRevision: {
			type: Boolean,
			required: true
		},
		needToReloadListing: {
			type: Function
		},
		beforeNavigate: {
			type: Function,
			required: false,
			default: null
		},
		revision: {
			type: Object,
			required: true
		},
		currentAdicional: {
			type: Object,
			required: true
		}
	},
	data: () => ({
		loadingData: false,
		loadingFilePath: false,
		showAttachments: false,
		viewerDocumentItem: null,
		viewerForgeItem: null
	}),
	methods: {
		scrollToAddObservation(){
			this.$emit('scrollToAddObservation')
		},
    async getFilesUrl(attachments, singleFile = false, download = false){
      if(singleFile){ attachments = [attachments] }
      this.loadingFilePath = true
      const files = await getPublicUrl({attachments, force_download: download})
      if(files.code === 200){
        files.files.forEach((file) => {
          window.open(file.url);
        })
      }
      this.loadingFilePath = false
    },
		previewAttachment(attachment){
			this.viewerDocumentItem = null
			this.viewerForgeItem = null

			if(attachment?.pathdoc?.path){
				this.viewerDocumentItem = attachment
				return
			}

			if(attachment?.forge_file?.translated){
				this.viewerForgeItem = attachment
				return
			}

			this.$store.globalStore.dispatch('addMessage', {
				message: 'Este archivo no tiene un visor disponible.',
				title: 'Vista previa no disponible',
				created: new Date(),
				type: 'warning',
				icon: 'mdi-eye-off-outline',
				color: '#FB8500'
			})
		},
		closeAttachmentViewer(){
			this.viewerDocumentItem = null
			this.viewerForgeItem = null
		},
		minimizeAttachmentViewer(item){
			if(!item) return
			this.$store.globalStore.commit('addFileToFileManagerHandler', item)
			this.closeAttachmentViewer()
		},
		onViewerError(){
			console.error('Attachment viewer failed to load')
		},
		onViewerLoad(){},
		async openItemMorphable(item){
			const typeMap = {
				'App\\Models\\TasksRestrictions': 'task',
				'App\\Models\\TasksRestrictionsInteractions': 'task_interaction',
				'App\\Models\\Rdi': 'rdi',
				'App\\Models\\RdiInteractions': 'rdi_interaction',
				'App\\Models\\Additional': 'additional',
				'App\\Models\\AdditionalRevision': 'additional_revision',
				'App\\Models\\AdditionalObservation': 'additional_observation'
			}
			const parentTypesMap = {
				'App\\Models\\TasksRestrictions': 'task',
				'App\\Models\\TasksRestrictionsInteractions': 'task',
				'App\\Models\\Rdi': 'rdi',
				'App\\Models\\RdiInteractions': 'rdi',
				'App\\Models\\Additional': 'additional',
				'App\\Models\\AdditionalRevision': 'additional',
				'App\\Models\\AdditionalObservation': 'additional'
			}
			if(!item || !typeMap[item.morphable_type] || !item.morphable_id) return

			const parentType = parentTypesMap[item.morphable_type]
			const data = {
				item_id: item.morphable_id,
				item_type: typeMap[item.morphable_type]
			}

			if(parentType === 'task'){
				this.$store.consultasStore.commit('setCurrentTarea', { loading: true })
			}
			else if(parentType === 'rdi'){
				this.$store.rdiStore.commit('setCurrentRDI', { loading: true })
			}
			else if(parentType === 'additional'){
				this.$store.adicionalesStore.commit('setCurrentAdicional', { loading: true })
			}

			this.closeAttachmentViewer()
			const element = await getParentElement(data)
			if(element.code !== 200) return

			if(parentType === 'task'){
				this.$store.consultasStore.commit('setCurrentTarea', element.task)
			}
			else if(parentType === 'rdi'){
				this.$store.rdiStore.commit('setCurrentRDI', element.rdi)
			}
			else if(parentType === 'additional'){
				this.$store.adicionalesStore.commit('setCurrentAdicional', element.additional)
			}
		},
	}
}
</script>

<style scoped>
  .text-primary{
    color: #2D4B95;
  }
	.revision-header{
		background-color: #5E85EF;
		color: white;
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
	}
	.revision-container{
		border: 1px solid #e2e2e2;
		border-bottom-left-radius: 8px;
		border-bottom-right-radius: 8px;
	}
	.revision-cost-container-inner{
		border: 1px solid grey;
	}
	.revision-cost-container-inner.dark{
		background-color: #e2e2e2;
	}
	table, th, td {
		border: 1px solid grey;
		border-collapse: collapse;
	}
</style>